@if(toggle) {
<div @flyInOut class="menu-container">
  <mat-icon class="close" (click)="close()">close</mat-icon>
  <div class="title">
    @if(appSettings.settings.theme) { <img src="/Styles/{{appSettings.settings.theme}}/Logo.png" /> }
    @if(!appSettings.settings.theme) { <img src="" /> }
    <div class="logo">
      @if(userLoggedIn) {
      <button type="button" mat-raised-button (click)="signOut()">
        <strong>{{ 'Intellitrailer.Menu.SignOut' | translate : 'Sign out' }}</strong>
        <mat-icon>login</mat-icon>
      </button>
      }
      @else {
      <button type="button" mat-raised-button (click)="navigate('MyPage.SignIn')">
        <strong>{{ 'Intellitrailer.Menu.SignIn' | translate : 'Sign in' }}</strong>
        <mat-icon>account_box</mat-icon>
      </button>
      }
      <!--<button *ngIf="userLoggedIn" style="margin-top: 25px;" mat-button (click)="deleteAccount()">Delete my account</button>-->
    </div>
  </div>
  @if(appSettings.meetsMinimumAppVersion(4.0)) {
  <div (click)="appService.openPermissions()" style="text-align: center; background: #eeeeee; padding: 5px;">
    @if(appService.Device.Bluetooth == 1 || appService.Device.Bluetooth == 3) { <mat-icon [ngClass]="{ red: appService.Device.Bluetooth == 0 || appService.Device.Bluetooth == 2, yellow: appService.Device.Bluetooth == 1, green: appService.Device.Bluetooth == 3 }">bluetooth_on</mat-icon> }
    @if(appService.Device.Bluetooth == 0 || appService.Device.Bluetooth== 2) { <mat-icon [ngClass]="{ red: appService.Device.Bluetooth == 0 || appService.Device.Bluetooth == 2, yellow: appService.Device.Bluetooth == 1, green: appService.Device.Bluetooth == 3 }">bluetooth_disabled</mat-icon> }
    @if(appService.Device.Location == 1 || appService.Device.Location == 3) { <mat-icon [ngClass]="{ red: appService.Device.Location == 0 || appService.Device.Location == 2, yellow: appService.Device.Location == 1, green: appService.Device.Location == 3 }">location_on</mat-icon> }
    @if(appService.Device.Location == 0 || appService.Device.Location == 2) { <mat-icon [ngClass]="{ red: appService.Device.Location == 0 || appService.Device.Location == 2, yellow: appService.Device.Location == 1, green: appService.Device.Location == 3 }">location_off</mat-icon> }
    <mat-icon [ngClass]="{ red: appService.Device.Camera == 0 || appService.Device.Camera == 2, yellow: appService.Device.Camera == 1, green: appService.Device.Camera == 3 }">photo_camera</mat-icon>
    @if(appService.Device.Nfc == 0) { <mat-icon style="transform: rotate(90deg); color: gray;">wifi_off</mat-icon>}
    @if(appService.Device.Nfc > 0) { <mat-icon style="transform: rotate(90deg)" [ngClass]="{ red: appService.Device.Nfc == 2, green: appService.Device.Nfc == 3 }">wifi_on</mat-icon> }
  </div>
  }
  <!--<div class="row">
    <div *ngIf="userLoggedIn" class="user-icon">
      <span class="material-icons">
        account_circle
      </span>
    </div>
    <div class="user-info">
      <span *ngIf="userLoggedIn && customer && customer.Firstname && customer.Lastname">{{ customer.Firstname }} {{ customer.Lastname }}</span>
      <span *ngIf="userLoggedIn && userDetails">{{ userDetails.Email }}</span>
    </div>
  </div>-->
<div class="menu-content">
  <!--<div class="row">
    <div class="menu-item" (click)="navigate('Start')">
      <span class="material-icons icon">home</span>
      <span class="menu-item-text">{{ 'Intellitrailer.MyPage.Overview.TitleStartpage' | translate : 'Start page' }}</span>
      <span class="material-icons">chevron_right</span>
    </div>
  </div>-->
  <div class="row gx-0" (click)="navigate('Start')">
    <div class="menu-item">
      <mat-icon>add</mat-icon>
      <span>{{ 'Intellitrailer.Booking.BeginBooking.TitleNewBooking' | translate : 'New booking' }}</span>
    </div>
  </div>
  <div class="row gx-0">
    <div class="menu-item" (click)="navigate('MyPage.Overview')">
      <mat-icon>account_box</mat-icon>
      <span>{{ 'Intellitrailer.MyPage.Overview.TitleMyBookings' | translate : 'My bookings' }}</span>
    </div>
  </div>
  @if(userLoggedIn) {
  <div class="row gx-0">
    <div class="menu-item" (click)="navigate('MyPage.Campaigns')">
      <mat-icon>grade</mat-icon>
      <span>{{ 'Intellitrailer.Menu.MenuItem.TitleMyCampaigns' | translate : 'My offers' }}</span>
    </div>
  </div>
  <div class="row gx-0">
    <div class="menu-item" (click)="navigate('MyPage.Settings.Authenticated')">
      <mat-icon>settings</mat-icon>
      <span>{{ 'Intellitrailer.Menu.MenuItem.Settings' | translate : 'Settings' }}</span>
    </div>
  </div>
  }
  @else {
  <div class="row gx-0">
    <div class="menu-item" (click)="navigate('MyPage.Settings')">
      <mat-icon>settings</mat-icon>
      <span>{{ 'Intellitrailer.Menu.MenuItem.Settings' | translate : 'Settings' }}</span>
    </div>
  </div>
  }
  @if(hasActiveCampaign) {
  <div class="row gx-0">
    <div class="menu-item" (click)="recieveClickOfferAction()">
      <mat-icon>share</mat-icon>
      <span>{{ 'Intellitrailer.Menu.MenuItem.TitleInviteFriends' | translate : 'Invite friends' }}</span>
    </div>
  </div>
  }
  <div class="row gx-0">
    <ng-container>
      <div class="menu-item" *ngFor="let option of this.menuOptions" (click)="navigate(option.route)">
        @if(option.label == 'FAQ') { <mat-icon>contact_support</mat-icon> }
        @if(option.label == 'GDPR') { <mat-icon>description</mat-icon> }
        @if(option.label != 'FAQ' && option.label != 'GDPR') { <mat-icon></mat-icon> }
        <span>{{ 'Intellitrailer.Menu.CustomMenuItem.' + option.label | translate }}</span>
      </div>
    </ng-container>
  </div>

  <div class="menu-bottom">
    @if(appSettings.appType == 'app' && this.appSettings.contextId.toLowerCase() == 'kanleiesunmanned_api'){
    <button mat-raised-button color="primary" class="smaller" (click)="chatbot.openChat()">{{ 'Intellitrailer.Rental.Menu.ContactUs' | translate : 'Contact us' }}</button>
    }
    @else {
    @if(showCustomerInfo && CustomerInfoList.length > 0) {
    <div class="row text-center gx-0 ps-4">
      <p>
        <strong>{{ 'Intelitrailer.Menu.CustomerService' | translate : 'Customer service'}}</strong>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <img width="32" height="32" [src]="country.flagPath">
        </button>
        <mat-icon [matMenuTriggerFor]="menu">arrow_drop_down</mat-icon>
      </p>
    </div>

    @if(selectedCustomerInfo.phone) { <a class="pe-3" href="tel:{{selectedCustomerInfo.phone}}"><mat-icon>call</mat-icon> <span dir="ltr">{{selectedCustomerInfo.phone}}</span></a> }
    @if(selectedCustomerInfo.email) {<p class="align-items-center pe-3"><mat-icon>mail</mat-icon> {{selectedCustomerInfo.email}}</p> }
    }
    @if(showCustomerInfo && CustomerInfoList.length <= 0) {
    <div class="row">
      <h2> {{ 'Intelitrailer.Menu.CustomerService' | translate : 'Customer service'}}</h2>
      <small> {{ 'Intelitrailer.Menu.CustomerServiceFallBack' | translate : 'For assistance, contact the local store directly.'}}</small>
    </div>
    }

    <!-- Menu for Languages - Customer Support Info -->
    <mat-menu #menu="matMenu" xPosition="after">
      <button mat-menu-item *ngFor="let c of countries" (click)="selectCountry(c)">
        <img width="32" height="32" [src]="c.flagPath">   {{ c.fullName }}
      </button>
    </mat-menu>
    }

    @if(version) {
    <div class="row text-center gx-0">
      <small>{{ 'Intellitrailer.Menu.Version' | translate : 'Version' }} {{version}}@if(shellVersion) { <ng-container> ({{shellVersion}})</ng-container> }</small>
    </div>
    }
  </div>
  @if(hasActiveCampaign && !closeInviteOption) {
  <div class="invite-card">
    <div class="row text-center">
      <!--<p class="invite-title"><strong>{{discount.AppMenuMessageTitle}}</strong></p>
      <p class="invite-text" [innerHTML]="discount.AppMenuMessageDescription"></p>-->
      <p><strong>{{ appMenuTitle }}</strong></p>
      <small [innerHTML]="appMenuDescription"></small>
    </div>
    <div class="row">
      <div class="col text-center">
        <button mat-raised-button color="primary" class="smaller" (click)="recieveClickOfferAction()">{{ 'Intellitrailer.Rental.Menu.cmdInvite' | translate : 'Invite' }}</button>
      </div>
    </div>
    <button class="invite-close" (click)="closeInvite()">✕</button>
  </div>
  }
</div>

</div>
}
<app-chatbot #chatbot></app-chatbot>

